import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import vuexI18n from 'vuex-i18n'
import flagIcon from 'vue-flag-icon'
import Buefy from 'buefy'
import localStorage from 'vue-localstorage'
import VueCroppie from 'vue-croppie'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import VueCookies from 'vue-cookies'

import { globalVars } from './globalVars'
import { translationsEn } from './store/i18n/en'
import { translationsTh } from './store/i18n/th'
import { translationsVi } from './store/i18n/vi'
import { Settings } from 'luxon'

Vue.config.productionTip = false

Vue.use(vuexI18n.plugin, store)
Vue.use(flagIcon)
Vue.use(Buefy, {
  defaultIconPack: 'fa'
})
Vue.use(localStorage)
Vue.use(VueCroppie)
Vue.use(Datetime)
Vue.use(VueCookies)

Vue.i18n.add('en', translationsEn)
Vue.i18n.add('th', translationsTh)
Vue.i18n.add('vi', translationsVi)

if (Vue.localStorage.get('language') !== null) {
  let language = Vue.localStorage.get('language').toLowerCase()
  if (language === '' || language === 'th') {
    language = 'th'
  } else if (language === 'vi') {
    language = 'vi'
  } else {
    language = 'en'
  }
  Vue.i18n.set(language)
  Settings.defaultLocale = language
} else {
  Vue.i18n.set('en')
  Settings.defaultLocale = 'en'
}

Vue.mixin({
  data: function () {
    return {
      get globalReadOnlyProperty () {
        return globalVars
      }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  localStorage,
  Settings,
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})

let handleProductSearchOutsideClick
Vue.directive('product-search-outside-click', {
  bind (el, binding, vnode) {
    handleProductSearchOutsideClick = (e) => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          if (typeof vnode.context.$parent.$refs.productSearchInput.$refs[refName] !== 'undefined') {
            const excludedEl = vnode.context.$parent.$refs.productSearchInput.$refs[refName]
            clickedOnExcludedEl = excludedEl.contains(e.target)
          }
        }
      })
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }
    document.addEventListener('click', handleProductSearchOutsideClick)
    document.addEventListener('touchstart', handleProductSearchOutsideClick)
  },
  unbind () {
    document.removeEventListener('click', handleProductSearchOutsideClick)
    document.removeEventListener('touchstart', handleProductSearchOutsideClick)
  }
})

let handleOrderSearchOutsideClick
Vue.directive('order-search-outside-click', {
  bind (el, binding, vnode) {
    handleOrderSearchOutsideClick = (e) => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          if (typeof vnode.context.$parent.$refs.orderSearchInput.$refs[refName] !== 'undefined') {
            const excludedEl = vnode.context.$parent.$refs.orderSearchInput.$refs[refName]
            clickedOnExcludedEl = excludedEl.contains(e.target)
          }
        }
      })
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }
    document.addEventListener('click', handleOrderSearchOutsideClick)
    document.addEventListener('touchstart', handleOrderSearchOutsideClick)
  },
  unbind () {
    document.removeEventListener('click', handleOrderSearchOutsideClick)
    document.removeEventListener('touchstart', handleOrderSearchOutsideClick)
  }
})



// WEBPACK FOOTER //
// ./src/main.js